'use strict'

class Groupon.Widgets.BackToTopButton
  constructor: ->
    return unless (@$back2top = $('#ls-back-to-top')).length
    # show when the header is not visible anymore
    @offset = $('.header-v2 header.header').height() * 1.5
    @visible = false

    # test for requestAnimationFrame
    if window.requestAnimationFrame
      # modern browser event binding + requestAnimationFrame
      fn = @requestTick
    else
      # legacy IE + browsers that don't support requestAnimationFrame
      fn = @showOrHide

    $(window).on 'scroll', _.throttle(fn, 1000)
    @bind()

  requestTick: =>
    window.requestAnimationFrame( @showOrHide )

  showOrHide: =>
    # y scroll position: modern browsers, IE9+
    y = window.scrollY or window.pageYOffset
    threshold = y > @offset
    if threshold and not @visible
      # set z-index before opacity change so we see transition
      @$back2top.css('z-index': 200)
      @$back2top.addClass('ls-back-to-top-visible').attr('aria-hidden', 'false')
      @visible = true
    else if @visible and not threshold
      @$back2top.attr('aria-hidden', 'true').removeClass('ls-back-to-top-visible')
      @visible = false

  bind: =>
    @$back2top.on 'click', =>
      # 'body, html' is REQUIRED as a browser hack to have jquery animate
      #  work with scrollTop cross browser
      $('body, html').animate({scrollTop: 0}, 500, =>
        @$back2top.attr('aria-hidden', 'true')
      )

    @$back2top.on 'transitionend', =>
      if @$back2top.css('opacity') is '0'
        @$back2top.css('z-index': -1)



// WEBPACK FOOTER //
// ./modules/gig_body/components/back2top/frontend/main.coffee